export class ScoreStorage {
    public static score: number = 0;

    public static setScore(score: number): void {
        this.score = score;
    }

    public static reset(): void {
        this.score = 0;
    }
}